import Utils from "../utils/utils";
import Projects from "./AppLib_Projects";
import Students from "./AppLib_Students";
import Tickets from "./AppLib_Tickets";

const AppLib = {
  get token() {
    return Utils.getToken();
  },
  Tickets,
  Projects,
  Students,
};

export default AppLib;
